export default __webpack_public_path__ + "static/media/exterior3.51ed86e2.jpeg";